export enum ActivityReason {
    ACTIVITY_CREATED = 'ACTIVITY_CREATED',
    ADDED_TO_INVOICE = 'ADDED_TO_INVOICE',
    INVOICE_PAID = 'INVOICE_PAID',
    INVOICE_PAYMENT_FAILED = 'INVOICE_PAYMENT_FAILED',
    INVOICE_UNCOLLECTIBLE = 'INVOICE_UNCOLLECTIBLE',
}